import useResident from 'hooks/useResident'
import { Navigate, useParams } from 'react-router-dom'
import ProfessionalContactForm from '../forms/ProfessionalContactForm'

const ProfessionalContactUpdateScreen = ({
  testId
}: {
  testId?: string
} = {}) => {
  const { id, index } = useParams()

  const { isLoading, resident, updateResident } = useResident({ id })

  if (!id) {
    return <Navigate to="/residents" />
  }

  const editedIndex = index ? parseInt(index, 10) : undefined

  if (editedIndex && Number.isNaN(editedIndex)) {
    // go to important contacts page
    return <Navigate to="../../" />
  }

  return (
    <div
      data-testid={
        testId
          ? `${testId}-professional-contact-update-screen`
          : 'professional-contact-update-screen'
      }
    >
      <ProfessionalContactForm
        editedIndex={editedIndex}
        onSubmit={updateResident}
        isLoading={isLoading}
        resident={resident}
        testId={testId}
      />
    </div>
  )
}

export default ProfessionalContactUpdateScreen
